import {
  Box,
  IconButton,
  ListItemText,
  MenuItem,
  TableCell,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material"
import { Delete } from "@mui/icons-material"
import { Controller, useFormContext } from "react-hook-form"
import { GraphTagsFormValues } from "@features/administration/products/EditProduct/GraphTagsForm/GraphTagsForm"
import { GRAPH_TAG_RULE_OPTIONS } from "@features/administration/products/EditProduct/graphTagsHelper"
import { memo } from "react"

type GraphTagRowProps = {
  index: number
  onDelete: (index: number) => void
}

const GraphTagRow = (props: GraphTagRowProps) => {
  const form = useFormContext<GraphTagsFormValues>()

  return (
    <TableRow>
      <TableCell>
        <strong>{props.index + 1}.</strong>
      </TableCell>
      <TableCell>
        <Controller
          control={form.control}
          name={`rows.${props.index}.name`}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              fullWidth
              size="small"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              InputLabelProps={{ shrink: true }}
            />
          )}
        />
      </TableCell>

      <TableCell>
        <Controller
          control={form.control}
          name={`rows.${props.index}.description`}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              fullWidth
              size="small"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              InputLabelProps={{ shrink: true }}
            />
          )}
        />
      </TableCell>

      <TableCell>
        <Controller
          control={form.control}
          name={`rows.${props.index}.rule`}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              fullWidth
              size="small"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              InputLabelProps={{ shrink: true }}
              select
              SelectProps={{
                renderValue: (value) =>
                  GRAPH_TAG_RULE_OPTIONS.find((option) => option.value === value)?.label ?? "",
              }}
            >
              {GRAPH_TAG_RULE_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value} sx={{ whiteSpace: "normal" }}>
                  <ListItemText
                    primary={option.label}
                    secondary={
                      <Box component="ul" sx={{ m: 0, pl: 2 }}>
                        {option.description.map((line) => (
                          <li key={line}>{line}</li>
                        ))}
                      </Box>
                    }
                  />
                </MenuItem>
              ))}
            </TextField>
          )}
        />
      </TableCell>

      <TableCell>
        <Tooltip title="Delete" arrow>
          <IconButton color="error" onClick={() => props.onDelete(props.index)}>
            <Delete />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  )
}

const MemoizedGraphTagRow = memo(GraphTagRow)

GraphTagRow.displayName = "GraphTagRow"

export default MemoizedGraphTagRow
